<div class="row">
    <div class="col-md-8  ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>
                        Introduction to Payout</h2>
                </div>
                <div class="col-md-2 col2"><button class="btn share"><img src="./assets/share (5).svg"
                            style="width: 30px;" alt=""></button>
                </div>
                <div class="col-md-12" (mouseover)="showpayment(true,'1')" (mouseout)="showpayment(false,'1')" id="1">
                    <div style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                        <iframe class="i-frame" src="https://www.youtube.com/embed/Ee8A2oDqDRw?si=wcJ62-H4WxaERYp_"
                            title="YouTube video player" frameborder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="2">
                    <h2>Introduction to Payouts</h2>
                    <label for="" class="mt-2">Welcome to the Payouts Documentation, a comprehensive guide to
                        understanding and implementing payout processes efficiently. It involves the transfer of funds
                        as compensation, salary, rewards, settlement of financial transactions, or fulfilment of
                        contractual agreements. </label>
                </div>
                <div class="col-md-12 mt-5  " (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="3">
                    <h2>Purpose of Payouts</h2>
                    <label for="" class="mt-3">The primary purpose of payouts is to facilitate the fair and timely
                        distribution of funds or rewards in different scenarios. The key objectives include:</label>

                    <h4 class="mt-4"><b>Compensation</b></h4>
                    <label for="">Ja Payouts are commonly used to compensate individuals or entities for products,
                        services, or work performed. This can include employee salaries, vendor payments, or payments
                        for goods and services.</label>

                    <h4 class="mt-4"><b>Rewards and Incentives</b></h4>
                    <label for="">Businesses often use payouts to distribute rewards, bonuses, or incentives to
                        individuals or teams for achieving specific goals, milestones, or performance targets.</label>

                    <h4 class="mt-4"><b>Financial Transactions</b></h4>
                    <label for="">Payouts play a crucial role in settling financial transactions. This can involve
                        refunding customers, reimbursing expenses, or fulfilling financial obligations resulting from
                        various business activities.</label>

                    <h4 class="mt-4"><b>Distribution of Earnings</b></h4>
                    <label for=""> In investment contexts, payouts represent the distribution of earnings or profits to
                        investors or shareholders. This can take the form of dividends, interest payments, or other
                        returns on investments.</label>
                </div>
                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="4">
                    <h2>
                        Payout Methods Explained
                    </h2>
                    <label for="">Payout methods are the different ways in which funds or rewards are distributed from
                        one party to another. The choice of payout method often depends on factors such as the nature of
                        the transaction, the preferences of the parties involved, and the technological infrastructure
                        available. Here are common payout methods explained:</label>

                    <h4 class="mt-4"><b>Bank Transfers</b></h4>
                    <label for="">This method involves transferring funds directly from one bank account to another. It
                        is a widely used and secure way to conduct payouts.</label>

                    <h4 class="mt-4"><b>Electronic Funds Transfer (EFT)</b></h4>
                    <label for="">Similar to bank transfers, EFT is a digital method that moves funds electronically
                        between bank accounts, eliminating the need for physical checks.</label>

                    <h4 class="mt-4"><b>Digital Wallet Transactions</b></h4>
                    <label for="">Payouts can be made to digital wallets, which are virtual platforms storing funds.
                        Recipients can then use the digital wallet balance for various transactions. </label>

                    <h4 class="mt-4"><b>Peer-to-Peer (P2P) Payment Apps</b></h4>
                    <label for="">Mobile applications facilitate direct payments between individuals, often linked to
                        bank accounts or credit cards.</label>
                </div>

                <div class="col-md-12 mt-5" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="5">
                    <h2>Use Cases of Payouts</h2>
                    <label for="">Payouts are versatile and find application in various industries and scenarios. Here
                        are common use cases illustrating the diverse ways in which payouts are employed:</label>

                    <h4 class="mt-4"><b>Employee Salaries</b></h4>
                    <label for="">Employers use payouts to compensate their employees for their work</label>

                    <h4 class="mt-4"><b>E-commerce Transactions</b></h4>
                    <label for="">Online retailers use payouts to refund customers, pay suppliers, and settle
                        transactions, ensuring a smooth flow of funds in the e-commerce ecosystem.</label>


                    <h4 class="mt-4"><b>Vendor Payments</b></h4>
                    <label for="">Companies make payouts to suppliers and vendors for goods and services provided,
                        maintaining healthy business relationships</label>


                    <h4 class="mt-4"><b>Freelancer Payments</b></h4>
                    <label for="">Employers use payouts to compensate freelancers for project work, providing a flexible
                        way to manage contract-based employment</label>


                    <h4 class="mt-4"><b>Dividends to Shareholders</b></h4>
                    <label for="">Companies issue payouts in the form of dividends to shareholders, distributing a
                        portion of profits as a return on their investments.</label>


                    <h4 class="mt-4"><b>Incentives and Rewards Programs</b></h4>
                    <label for="">Businesses use payouts as incentives or rewards for employees, customers, or partners
                        to encourage desired behaviours or achievements.</label>


                    <h4 class="mt-4"><b>Rent and Real Estate Payments</b></h4>
                    <label for="">Landlords receive payouts from tenants as rent payments, streamlining the process of
                        property management.</label>


                    <h4 class="mt-4"><b>Government Aid and Social Programs</b></h4>
                    <label for="">Governments use payouts to distribute financial aid and support through social welfare
                        programs, ensuring assistance to eligible individuals.</label>
                </div>

            </div>
        </div>
    </div>
    <div class="col-md-4 hide-tbl content2 ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>

                </div>
                <div class="col-md-12 mt-2">
                    <!-- <a href="#1">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                                    alt=""> &nbsp;</div>
                            <div class="col-md-10">
                                <span class="videoHover" style="cursor: pointer;"
                                    [ngClass]="{'video':colors=='1'}" (click)="color('1')"
                                    >
                                    Introduction to
                                    Payment Gateways
                                </span>
                              
                            </div>
                        </div>
                    </a> -->
                </div>
                <div class="col-md-12 ">
                    <a href="#2">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')"> Understanding Payouts </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#3">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')">
                                    Purpose of Payouts? </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#4">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">Payout methods </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 ">
                    <a href="#5">
                        <div class="row">
                            <div class="col-md-2"> <img src="./assets/edit.svg" class="tab-icon intro" alt=""> &nbsp;
                            </div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">Use cases of Payouts</span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-2">

                    <div class="row">
                        <div class="col-md-2"> <img src="./assets/ppt.svg" class="tab-icon intro" alt="">
                        </div>
                        <div class="col-md-8">
                            <a href="./assets/PPT/Payouts 1.pdf" target="_blank">
                                <span style="cursor: pointer;" class="pptHover" [ngClass]="{'ppt':colors=='4'}"
                                    (click)="color('4')">
                                    Payouts Overview</span>
                            </a>
                        </div>
                        <div class="col-md-2">
                            <a href="./assets/PPT/Payouts.pdf" download><img src="./assets/Download.svg" alt=""
                                    width="100%"></a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8    ">
                <a [routerLink]="['/create-profile']"><button class="btn btn-color"
                        (click)="menues('Creating Profile')"> <img src="./assets/Arrow 3.svg" alt=""> &nbsp;Creating
                        Profile
                        &nbsp;</button></a>
            </div>
            <div class="col-md-4    ">
                <a [routerLink]="['/create-payout']"> <button class="btn btn-color">Create Payout
                        &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
            </div>
        </div>
    </div>
</div>